module.exports = __webpack_public_path__ + "img/af.b040d01.svg";